<template>
    <d-contract-edit
        v-model        = "edit"
        :title         = "isLim ? 'Liftmanagement' : 'DLS'"
        :type-id       = "typeId"
        :contract-id   = "contractId"
        :company-id    = "companyId"
        :customer-id   = "companyId"
        :show-customer = "false"
        @initialized   = "onInitialized"
        @saved         = "onSaved"
    >
        <template v-slot:terms>
            <div class="pt-0 h-100">
                <c-contract-lim-terms
                    :contract   = "contract"
                    :key        = "refresh"
                    :show-title = "false"
                    style       = "margin-top: -4px;"
                />
            </div>
        </template>
        <template v-slot:post>
            <v-row class="no-frame" v-if="isLim">
                <v-col class="no-frame pr-2">
                    <f-currency-field
                        class     = "money"
                        :label    = "$t('contract.lim.pricePerMonth')"
                        v-model   = "contract.pricePerMonth"
                        :rules    = "[ requiredRule ]"
                    />
                </v-col>
                <v-col class="no-frame pl-2">
                    <f-currency-field
                        class     = "money"
                        :label    = "$t('contract.lim.lgsPerMonth')"
                        v-model   = "contract.lgsPerMonth"
                    />
                </v-col>
            </v-row>
        </template>
    </d-contract-edit>
</template>

<script>

import Core              from "@/modules/core/service/Core";
import Contract          from "@/modules/msd/company/contract/service/Contract";
import DContractEdit     from "@/modules/msd/company/contract/components/controls/DContractEdit";
import CContractLimTerms from "@/modules/msd/company/contract/components/controls/lim/CContractLimTerms";
import FCurrencyField from "@/modules/core/components/utils/FCurrencyField.vue";

export default {
    name: "DContractLimEdit",

    components: {
        FCurrencyField,
        CContractLimTerms,
        DContractEdit,
    },

    props: {
        value: {

        },

        typeId: {
            required: false ,
            type    : Number,
            default : function () {
                return null
            }
        },

        contractId: {
            required: false,
            type    : Number,
            default : function () {
                return null
            }
        },

        companyId: {
            required: false,
            type    : Number,
            default: function () {
                return null;
            }
        },
    },

    data: () => ({
        type    : 1,
        edit    : false,
        contract: null,
        refresh : 0,
    }),

    watch: {
        value () {
            this.edit = this.value;
        },

        edit () {
            if (!this.edit) {
                this.$emit("input", false)
            }
        }
    },

    computed: {
        isLim () {
            return this.typeId === Contract.enums.types.lim;
        },

        requiredRule() {
            return Core.rule.required;
        },
    },

    methods: {
        onInitialized (contract) {
            this.contract = contract;
            this.refresh ++;
        },

        onSaved (contract) {
            Core.fire.saved(this, contract);
        }
    }
}
</script>

<style scoped>

</style>